import store from '@/store';

const W3CWebSocket = require('websocket').w3cwebsocket;

export default function connect() {
  const client = new W3CWebSocket(process.env.VUE_APP_WEBSOCKET);

  client.onerror = function () {
    console.log('Connection Error');
  };

  client.onopen = function () {
    console.log('WebSocket Client Connected');
    store.dispatch('setSocket', client);
  };

  client.onclose = function () {
    console.log('Client Closed');
    connect();
  };

  client.onmessage = function (e) {
    console.log(e);
  };
}
